import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BaseService } from './base/base.service';

import { AppliedAdjustment, Summary } from '../models';
import { PagedResponse, ObjectResponse } from '../interfaces';
import { AppConfig } from './app-config';

@Injectable()
export class AppliedAdjustmentsService extends BaseService<AppliedAdjustment> {
  constructor(http: HttpClient, protected config: AppConfig) {
    super(http, config);
  }

  // TODO: override, delete after all responses refactored
  public show(id: number): Observable<ObjectResponse<AppliedAdjustment>> {
    return this.http.get<ObjectResponse<AppliedAdjustment>>(`${this.getResourceUrl()}${id}`);
  }

  public listOfSummaries(tbaId: number, queryString?: string): Observable<PagedResponse<Summary>> {
    const apiUrl = this.applyQueryString(queryString, `${this.getResourceUrl()}${tbaId}/summaries`);

    return this.http.get<PagedResponse<Summary>>(apiUrl);
  }

  protected getResourceUrl(): string {
    return `${this.baseUrl}applied-adjustments/`;
  }
}
